import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/sub-catalogs";

const getAll = (catalogId) =>
  axios.get(API_URL, { params: catalogId ? { catalog_id: catalogId } : {} });

const get = (id) => axios.get(`${API_URL}/${id}`);

const create = (data) =>
  axios.post(API_URL, data, { headers: authHeader() });

const update = (id, data) =>
  axios.put(`${API_URL}/${id}`, data, { headers: authHeader() });

const remove = (id) =>
  axios.delete(`${API_URL}/${id}`, { headers: authHeader() });

const SubCatalogService = { getAll, get, create, update, remove };

export default SubCatalogService;
